import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Input, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdLockReset } from "react-icons/md";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import SwitchWithLoader from "../../Components/CustomComponents/SwitchWithLoader.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import UserAvatar from "../../Components/CustomComponents/UserAvatar.js";
import ChangePasswordModal from "../../Components/Modals/ChangePasswordModal.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import {
  useBlockUserMutation,
  useUnBlockUserMutation,
} from "../../Data/services/generalUserApi.js";
import { useGetAllUsersQuery } from "../../Data/services/userApi.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import _ from "lodash";

const UserManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });
  const status = watch("status");
  // console.log(status);

  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [sendCoinModal, setSendCoinModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [forView, setForView] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllUsersQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
        ...(status && status === "all"
          ? { is_blocked: "" }
          : { is_blocked: status === undefined ? "" : status }),
      },
      { refetchOnMountOrArgChange: true }
    );

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  // console.log(data);

  // MARK: MOCKUP DATA
  // const dummyData = {
  //   data: [
  //     {
  //       name: "customer five",
  //       email: "customer5@yopmail.com",
  //       mobile_no: "+11234567811",
  //       slug: "34996c3c-fc7e-4302-a0e7-a6df3074de29",
  //       image_url: "https://api.wow.trangotechdevs.com/user-placeholder.jpeg",
  //       is_blocked: false,
  //     },
  //     {
  //       name: "customer five",
  //       email: "customer5@yopmail.com",
  //       mobile_no: "+11234567811",
  //       slug: "34996c3c-fc7e-4302-a0e7-a6df3074de29",
  //       image_url: "https://api.wow.trangotechdevs.com/user-placeholder.jpeg",
  //       is_blocked: false,
  //       total_completed_projects: 10,
  //       total_ongoing_projects: 5,
  //     },
  //     {
  //       name: "customer five",
  //       email: "customer5@yopmail.com",
  //       mobile_no: "+11234567811",
  //       slug: "34996c3c-fc7e-4302-a0e7-a6df3074de29",
  //       image_url: "https://api.wow.trangotechdevs.com/user-placeholder.jpeg",
  //       is_blocked: false,
  //     },
  //     {
  //       name: "customer five",
  //       email: "customer5@yopmail.com",
  //       mobile_no: "+11234567811",
  //       slug: "34996c3c-fc7e-4302-a0e7-a6df3074de29",
  //       image_url: "https://api.wow.trangotechdevs.com/user-placeholder.jpeg",
  //       is_blocked: false,
  //     },
  //     {
  //       name: "customer five",
  //       email: "customer5@yopmail.com",
  //       mobile_no: "+11234567811",
  //       slug: "34996c3c-fc7e-4302-a0e7-a6df3074de29",
  //       image_url: "https://api.wow.trangotechdevs.com/user-placeholder.jpeg",
  //       is_blocked: false,
  //     },
  //   ],
  //   links: {
  //     total: 3,
  //     per_page: 5,
  //     current: 2,
  //     prev: 1,
  //     next: 3,
  //     total_records: 14,
  //   },
  // };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setDataFetched(false);
  };

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const handleBlockModalOpen = () => {
    setViewModal(true);
  };

  // const handleBlockModalClose = () => {
  //   setViewModal(false);
  //   setEditedData("");
  // };

  // const handleSendCoinModalOpen = () => {
  //   setSendCoinModal(true);
  // };

  // const handleSendCoinModalClose = () => {
  //   setSendCoinModal(false);
  //   setEditedData("");
  // };

  const handlePasswordModalOpen = () => {
    setPasswordModal(true);
  };

  const handlePasswordModalClose = () => {
    setPasswordModal(false);
    setEditedData("");
  };

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();
  // const [userBlockOrUnBlock, { isLoading: isSwitching }] =
  //   useBlockUnblockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      // const response = await userBlockOrUnBlock({ id: userSlug });
      // console.log(response);
      let response;
      if (isBlock) {
        response = await unBlockUser({ id: userSlug });
      } else {
        response = await blockUser({ id: userSlug });
      }
      console.log(response);

      if (response.data.code === 200) {
        await refetch();
        setLoading(false);
        // handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  // const handleDeleteModalOpen = () => {
  //   setDeleteModal(true);
  // };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  // const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const deleteData = async (slug) => {
    // try {
    //   // const { data } = await deleteUser(slug);
    //   // console.log(data);
    //   if (data.code === 200) {
    //     // await refetch();
    //     handleDeleteModalClose();
    //     SuccessToast(data.message);
    //   }
    // } catch (error) {
    //   // console.log(error);
    //   Toast(error.message, "error");
    // }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
    // return <ClipLoader color="#1C75BC" />;
  }

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerStyle: {
        // width: "150px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        return (
          <UserAvatar
            image_url={row.image_url}
            username={`${
              cellContent ? cellContent : `${row.firstname} ${row.lastname}`
            }`}
          />
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return <span className="lc-1"> {row.email}</span>;
      },
    },
    {
      dataField: "mobile_no",
      text: "Phone",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "150px",
      },
      formatter: (cellContent, row) => {
        return <span className="lc-1"> {row.mobile_no}</span>;
      },
    },
    {
      dataField: "is_blocked",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <SwitchWithLoader
            isChecked={!row.is_blocked}
            // isLoading={isBlocking || isUnBlocking}
            onChange={() => handleBlockOrUnblock(row.id, row.is_blocked)}
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              {/* <ToolTip placement={"top"} content={"View Details"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setForView(true);
                    setEditedData(row);
                    handleBlockModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <IoIosEye size={22} />
                  </span>
                  {/* <span className="d-none d-xl-block">View</span> */}
              {/* </div>
              </ToolTip> 
              */}

              <ToolTip placement={"top"} content={"Change Password"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setForView(true);
                    setEditedData(row);
                    handlePasswordModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <MdLockReset size={22} />
                  </span>
                  {/* <span className="d-none d-xl-block">Change Pass</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {passwordModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <ChangePasswordModal
            forView={forView}
            handleBlockModalClose={handlePasswordModalClose}
            data={editedData}
            // onAction={handlePassword}
            loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {/* {viewModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <CustomerViewModal
            forView={forView}
            handleBlockModalClose={handleBlockModalClose}
            data={editedData}
            onAction={handleBlockOrUnblock}
            loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )} */}

      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            // isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"User Management"} classes="text-black" />
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex justify-content-end align-items-center gap-2">
              <Input
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <SelectFieldComponent
                    firstOption={_.isEmpty(value) ? "Select Status" : value}
                    optionsList={filterData}
                    onSelectChange={onChange}
                  />
                )}
              />
            </div>
          </Col>
        </Row>
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <Table
            // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
            data={rowData || []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
            // refetch={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default UserManagementScreen;
